import axios from 'shared/util/axios';

export const saveContentToHorizon = (
  siteId: number,
  pageId: number,
  widgetId: string,
  content: string
): Promise<any> => {
  const data = {
    siteId: siteId,
    pageId: pageId,
    widgetId: widgetId,
    content: content,
  };

  return axios
    .post(`horizon-content-api/content`, data)
    .then(response => response.data)
    .catch(error => {
      return Promise.reject(error);
    });
};

export const updateContentToHorizon = (
  id: number,
  content: string
): Promise<any> => {
  const data = {
    id: id,
    content: content,
  };
  return axios
    .patch(`horizon-content-api/content`, data)
    .then(response => response.data)
    .catch(error => {
      return Promise.reject(error);
    });
};

export const saveOrUpdateContentToHorizon = async (
  siteId: number,
  pageId: number,
  widgetId: string,
  content: string
): Promise<any> => {
  try {
    const response = await fetchContentFromHorizon(siteId, pageId, widgetId);
    if (
      response &&
      response.content &&
      response.content.length > 0 &&
      response.content[0].id
    ) {
      return updateContentToHorizon(response.content[0].id, content);
    }
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return saveContentToHorizon(siteId, pageId, widgetId, content);
    }
    return Promise.reject(error);
  }
};

export const fetchContentFromHorizon = (
  siteId: number,
  pageId: number,
  widgetId: string
): Promise<any> => {
  const params = {
    sbSiteId: siteId.toString(),
    sbPageId: pageId.toString(),
    sbWidgetId: widgetId,
  };
  const queryString = new URLSearchParams(params).toString();
  return axios
    .get(`horizon-content-api/widget-content?${queryString}`)
    .then(response => response.data)
    .catch(error => {
      return Promise.reject(error);
    });
};

export const deleteContentFromHorizon = (contentId: number): Promise<any> => {
  return axios
    .delete(`horizon-content-api/content/${contentId}`)
    .then(response => response.data)
    .catch(error => {
      return Promise.reject(error);
    });
};

export const deleteContentIfExists = async (
  siteId: number,
  pageId: number,
  widgetId: string
): Promise<void> => {
  try {
    const response = await fetchContentFromHorizon(siteId, pageId, widgetId);
    if (
      response &&
      response.content &&
      response.content.length > 0 &&
      response.content[0].id
    ) {
      await deleteContentFromHorizon(response.content[0].id);
    }
  } catch (error) {
    console.error('Error fetching or deleting content:', error);
  }
};
